class ComponentTabs extends HTMLElement {
  constructor() {
    super();

    this.container = this;
    this.tabsTitle = this.container.querySelectorAll('.js-tab-title');
    this.index = 1;
    if (this.container.querySelectorAll('.js-tab-title').length > 0) {
      this.querySelectorAll('.js-tab-title').forEach(
        (tabTitle) => tabTitle.addEventListener('click', this.activeTab.bind(this))
      );
    }
  }

  activeTab(e) {
    if (!e.currentTarget.classList.contains('active')) {
      this.index = e.currentTarget.getAttribute('data-index');

      this.container.querySelectorAll('.js-tab-title.active').forEach((tabTitle) => {
        tabTitle.classList.remove('active');
      });
      this.container.querySelector('.js-tab-content.active').classList.remove('active');

      this.container.querySelector('.js-tab-title-accordion').textContent = e.currentTarget.textContent;

      e.currentTarget.classList.add('active');
      this.container.querySelector('.js-tab-content[data-index="' + this.index + '"]').classList.add('active');
    }
  }
}

customElements.define("component-tabs", ComponentTabs);